import globalAxios from "../GlobalAxios";

const loginApi = async (email, password) => {
    const credentials = btoa(`${email}:${password}`);
    //console.log('credentials', credentials);

    const result = await globalAxios.post("/api/auth/login", {}, {
        headers: {
            'Authorization': `Basic ${credentials}`
        },
        withCredentials: true
    });
    //console.log('login', result);
    return result.data;
};

const logoutApi = async () => {
    try {
        await globalAxios.post('/api/auth/logout');
        sessionStorage.removeItem('AccessToken');
    } catch (error) {
        console.error('error', error);
    }
};

const userDataApi = async (id) => {
    try {
        const res = await globalAxios.get(`/api/user/data/${id}`);
        return res.data;
    } catch (error) {
        console.error('error', error);
    }
}

const register = async (registerData) => {
    try {
        const res = await globalAxios.post('/api/user/register', registerData);
        return res.data;
    } catch (error) {
        // console.error("error", error);
        return error;
    }
}

const changePassword = async (data) => {
    try {
        const res = await globalAxios.post('/api/user/changepassword', data);
        return res.data;
    } catch (error) {
        // console.error("error", error);
        return error;
    }
}

const checkDuplicateUseremailApi = async (email) => {
    email.trim();

    const result = await globalAxios.get("/api/auth/check-duplicate", {
        params: {
            email: email
        }
    })
    return result;
}

const menuListApi = async () => {
    const res = await globalAxios.get("/api/auth/getmenu");
    return res.data;
}

const userSettingMenuItems = async () => {
    try {
        const res = await globalAxios.get('/api/user/menu-items/user-setting');
        return res.data;
    } catch (error) {
        console.error('error', error);
        return { data: [] };
    }
}

const playeroptionApi = async () => {
    const res = await globalAxios.get("/api/auth/playeroption");
    return res.data;
}

const playeroptionChange = async (data) => {
    const res = await globalAxios.post("/api/auth/player_option_change", data);
    return res.data;
}

const uploadoptionApi = async () => {
    const res = await globalAxios.get("/api/auth/uploadoption");
    return res.data;
}

const uploadoptionChange = async (data) => {
    const res = await globalAxios.post("/api/auth/upload_option_change", data);
    return res.data;
}

const admincheck = async () => {
    const res = await globalAxios.get("/api/auth/admincheck");
    return res.data;
}


const listApi = async () => {
    try {
        const res = await globalAxios.get('/api/user/list');
        return res.data;
    } catch (error) {
        console.error("error", error);
    }
}

const sendEmailApi = async (data) => {
    try {
        const res = await globalAxios.post('/api/resetPassword', data);
        return res.data;
    } catch (error) {
        console.error("error", error);
    }
}

const resetPasswordApi = async (data) => {
    try {
        const res = await globalAxios.post('/api/resetPassword', data);
        return res.data;
    } catch (error) {
        console.error("error", error);
    }
}

const changeUserData = async (data) => {
    try {
        const res = await globalAxios.post('/api/user/chagneuserdata', data);
        return res.data;
    } catch (error) {
        console.error("error", error);
    }
}

const deleteApi = async (data) => {
    try {
    //   const res = await globalAxios.delete('/api/user/deleteUser', { data });
    const res = await globalAxios.delete('/api/user/delete', { data });
      return res.data;
    } catch (error) {
    //   console.error("error", error);
    return error;
    }
  }

export default {
    loginApi,
    logoutApi,
    register,
    checkDuplicateUseremailApi,
    menuListApi,
    userSettingMenuItems,
    playeroptionApi,
    playeroptionChange,
    uploadoptionApi,
    uploadoptionChange,
    admincheck,
    listApi,
    userDataApi,
    changePassword,
    sendEmailApi,
    resetPasswordApi,
    changeUserData,
    deleteApi
};
